import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { getGlobal } from "../getGlobal";
const theGlobal = getGlobal();
const useRerenderOnResize = () => {
    const [, setWindowSize] = useState("0x0");
    const windowResizeCallback = useCallback(() => setWindowSize(`${theGlobal.innerWidth}x${theGlobal.innerHeight}`), []);
    useEffect(() => {
        theGlobal.addEventListener("resize", windowResizeCallback);
        return () => theGlobal.removeEventListener("resize", windowResizeCallback);
    }, [windowResizeCallback]);
};
const MatchesMediaSwitcher = ({ mediaQueries = [], children = [], }) => {
    useRerenderOnResize();
    if (mediaQueries.length !== children.length)
        throw new Error("Non-matching number of children & media queries");
    if (!theGlobal.matchMedia)
        return _jsx(_Fragment, { children: children[0] });
    const matchingIndex = mediaQueries.findIndex((mediaQuery) => theGlobal.matchMedia(mediaQuery).matches);
    return _jsx(_Fragment, { children: children[matchingIndex] || null });
};
export { MatchesMediaSwitcher };
